<div class="row">
    <div class="col-12 text-center">
        <p>Sucesso, Fulano! Parcelamento contratado!</p>
        <p>Agora precisamos saber como você quer receber sua cópia do contrato e os boletos de pagamento do carnê
            digital: (Basta selecionar as opçõoes que desejar)</p>
    </div>
</div>

<div class="row mt-3 ml-5">
    <div class="col-12">
        <div class="form-group form-check">
            <input type="checkbox" class="form-check-input" id="exampleCheck1">
            <label class="form-check-label" for="exampleCheck1">WhatsApp</label>
          </div>
    </div>

    <div class="col-12">
        <div class="form-group form-check">
            <input type="checkbox" class="form-check-input" id="exampleCheck1">
            <label class="form-check-label" for="exampleCheck1">E-mail</label>
          </div>
    </div>
</div>

<div class="row">
    <div class="col-12 d-flex justify-content-center">
        <button class="btn btn-primary" (click)="next()">Continuar</button>
    </div>
</div>